<template>
  <div class="loader">
    <div indeterminate color="primary" :size="50"></div>
    <div class="text" v-if="text">{{ text }}</div>
  </div>
</template>
<script>
export default {
  props: {
    text: {}
  }
}
</script>
<style scoped lang="scss">

.loader {
  padding: 20px 0;

  & > * {
    display: block;
    margin: 0 auto;
  }

  .text {
    margin-top: 20px;
    text-align: center;
  }
}

</style>
